if (!customElements.get('product-modal')) {
  // 開いているモーダルを追跡するための静的レジストリ
  const openModals = new Set();

  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        
        // レスポンシブ対応のためのメディアクエリリスナーを追加
        this.setupResponsiveHandling();
      }
      
      // レスポンシブ対応の設定
      setupResponsiveHandling() {
        // 初期状態でのスタイル適用
        this.applyAppropriateStyles();
        
        // ウィンドウサイズ変更時にスタイルを更新
        this.onResponsiveResize = this.applyAppropriateStyles.bind(this);
      }
      
      connectedCallback() {
        super.connectedCallback();
        window.addEventListener('resize', this.onResponsiveResize);
        this.applyAppropriateStyles();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResponsiveResize);
        clearTimeout(this.mediaStyleTimeout);
        openModals.delete(this);
      }

      // 適切なスタイルを適用するメソッド
      applyAppropriateStyles() {
        // モーダルコンテナを取得
        const modalContainer = this.querySelector('.product-media-container') || 
                              this.querySelector('.product-media-list') || 
                              this.querySelector('[role="document"]');
                              
        if (modalContainer) {
          // すべてのメディアアイテムを取得
          const mediaItems = this.querySelectorAll('[data-media-id]');
          
          // iPad・タブレットサイズでのスタイル調整
          if (window.innerWidth >= 768) {
            // 一枚ずつ表示するためのスタイルを適用
            modalContainer.style.display = 'block';
            modalContainer.style.overflowX = 'hidden';
            
            // アクティブでないメディアアイテムを非表示に
            mediaItems.forEach(item => {
              if (!item.classList.contains('active')) {
                item.style.display = 'none';
              } else {
                item.style.display = 'block';
              }
            });
          } else {
            // モバイルサイズではデフォルトの動作に戻す
            modalContainer.style.display = '';
            modalContainer.style.overflowX = '';
            
            mediaItems.forEach(item => {
              item.style.display = '';
            });
          }
        }
      }

      hide() {
        super.hide();
        // レジストリからこのモーダルを削除
        openModals.delete(this);
      }

      show(opener) {
        // 他の開いているモーダルをすべて閉じる
        this.closeAllExcept(this);
        
        super.show(opener);
        this.showActiveMedia();
        
        // モーダル表示時にスタイルを適用
        this.applyAppropriateStyles();
        
        // レジストリにこのモーダルを追加
        openModals.add(this);
      }

      // このモーダル以外のすべてのモーダルを閉じるメソッド
      closeAllExcept(exceptModal) {
        openModals.forEach(modal => {
          if (modal !== exceptModal) {
            modal.hide();
          }
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        
        // アクティブなメディアが表示されたら、スタイルを再適用
        this.mediaStyleTimeout = setTimeout(() => {
          this.applyAppropriateStyles();
          activeMedia.scrollIntoView();
        }, 10);
        
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}